import apiRequest from './client';

// Catalogue des tirages visibles par la company connectee : le catalogue GLOBAL
// (Tirage.company NULL, gere par le superadmin, `is_global: true`) + les tirages
// PRIVES crees par CETTE company elle-meme (`is_global: false`) — cf.
// TirageViewSet.get_queryset(), prelote-backend/tirages/views.py.
export const listTirages = () => apiRequest('/tirages/');

// CRUD en libre-service (demande explicite 2026-09-22) : une company peut créer/
// modifier/supprimer SES PROPRES tirages, jamais le catalogue global ni ceux
// d'une autre company (`company` est toujours force server-side, jamais envoye
// ici — cf. TirageViewSet.perform_create). Toucher un tirage global ou etranger
// via update/delete echoue en 404 (get_queryset le retire du scope d'ecriture).
export const createTirage = (data) => apiRequest('/tirages/', { method: 'POST', body: data });

export const updateTirage = (id, data) => apiRequest(`/tirages/${id}/`, { method: 'PATCH', body: data });

export const deleteTirage = (id) => apiRequest(`/tirages/${id}/`, { method: 'DELETE' });

// Central > Close Sales : fermetures de tirage de la company connectee.
// Une fermeture = { weekday: 0-6 } (recurrente, 0=lundi) OU { date: 'YYYY-MM-DD' }.
export const listTirageClosures = ({ tirage } = {}) => {
  const qs = new URLSearchParams();
  if (tirage) qs.set('tirage', tirage);
  const s = qs.toString();
  return apiRequest(`/tirage-closures/${s ? `?${s}` : ''}`);
};

export const createTirageClosure = (data) =>
  apiRequest('/tirage-closures/', { method: 'POST', body: data });

export const deleteTirageClosure = (id) =>
  apiRequest(`/tirage-closures/${id}/`, { method: 'DELETE' });
